import React from 'react'

import { Toolbar } from '#components/Toolbar'

import styles from './MiniHeader.module.scss'

// TODO: Export components individually, preserving callers, in a follow-up.
// These existing compound exports are retained for the Oxlint 1.86 upgrade.
// oxlint-disable-next-line react/only-export-components
const LeftSection = ({ children }: { children: React.ReactNode }) => (
  <Toolbar.Section position="left" className={styles.leftSection}>
    {children}
  </Toolbar.Section>
)

// oxlint-disable-next-line react/only-export-components
const RightSection = ({ children }: { children: React.ReactNode }) => (
  <Toolbar.Section position="right" className={styles.rightSection}>
    {children}
  </Toolbar.Section>
)

const MiniHeader = {
  LeftSection,
  RightSection,
}

export default MiniHeader
